/**
 * Created by guhaikuan on 2020/7/16
 */
var requireNativeComponent = function requireNativeComponent() {
  return {};
};

export default requireNativeComponent;